import _ from "lodash";
import React, { useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import { Controller } from "react-hook-form";
import { fetchGetCrmStatuses } from "../queries/crmStatuses";
import JsonApiDataSelect from "./JsonApiDataSelect";

export const CrmStatusSelect = ({ clearOption, ...jsonApiSelectProps }: any) => {
  const dispatch = useDispatch();
  const statusesQuery = useQuery(["crmStatuses"], fetchGetCrmStatuses(dispatch));
  const statusOptions = useCallback((item: any) => {
    return {
      key: item.id,
      value: item.attributes.name,
      text: item.attributes.name,
    };
  }, []);
  const memoizedClearOption = useMemo(
    () =>
      typeof clearOption === "undefined"
        ? {
            key: "",
            value: "",
            text: "None",
          }
        : null,
    [clearOption],
  );

  const filterStatuses = function (status: any): boolean {
    const name = _.get(status, ["attributes", "name"], "").toString().toLowerCase();
    return !name.includes("work done");
  };

  return (
    <JsonApiDataSelect
      {...Object.assign({}, { placeholder: "Status" }, jsonApiSelectProps)}
      query={statusesQuery}
      toOptions={statusOptions}
      clearOption={memoizedClearOption}
      filterOptions={filterStatuses}
    />
  );
};

export const ControlledCrmStatusSelect = ({ name, control, ...statusSelectProps }: any) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ onChange, value }) => (
        <CrmStatusSelect
          {...statusSelectProps}
          name={name}
          onChange={(e: any, { value }: any) => onChange(value)}
          value={value}
        />
      )}
    />
  );
};

export default CrmStatusSelect;
